import reducer, { selectors, types } from "./ducks"
import Loadable from "base_components/Loadable"
import * as actions from "./thunks"
const pages = {
  Landing: Loadable({
    loader: () => import("./LandingPage")
  })
}
export { pages, reducer, selectors, types, actions }
